import { Injectable, Output } from '@angular/core';
import { DmsHttp } from '../../classes/dms-http';
import { HttpClient } from '@angular/common/http';
import { ISearchVehicleBoxResponse } from './search-vehicle-box.response';
import { Subject } from 'rxjs';
import { ChildsMenuEnum } from '../../enums/childs-menu.enum';
import { EventEmitter } from '@angular/core';
import { LoadingService } from '../../../shared/loading/loading.service';

@Injectable()
export class SearchVehicleBoxService extends DmsHttp {

    public updateVehicle = new Subject<ISearchVehicleBoxResponse>();

    isLoading = false;
    _urlSearch: string;

    _transmitter: string;

    public dataBoxResults: any[] = [];

    set urlSearch(url: string) {
        this._urlSearch = url;
    }

    get urlSearch() {
        return this._urlSearch;
    }

    constructor(http: HttpClient, private loadingService: LoadingService) {
        super(http, null);

    }

    set transmitter(value) {
        this._transmitter = value;
    }
    get transmitter() {
        return this._transmitter;
    }

    observerUpdateVehicle() {
        return this.updateVehicle.asObservable();
    }

    searchBoxResults(body: any) {

        if (this._transmitter === 'recepcionVO') {
            this.urlSearch = `Services/Workshop/VehicleService.svc/FindByVinAndPlateForVOReception`;
            body.entityState = 2;
        } else {
            this.urlSearch = `Services/Workshop/VehicleService.svc/FindAllTypesByVinAndPlate`;
            body.entityState = 2;
        }

        body.pageInfo = {
            Number: 1,
            Size: 9999
        };
        this.isLoading = true;
        this.dataBoxResults = [];
        this.newPost(this.urlSearch, body).subscribe((resp: any) => {
            this.isLoading = false;
            if (this._transmitter === 'recepcionVO') {
                this.dataBoxResults = [...resp.Content];
            } else {
                this.dataBoxResults = [...resp];
            }

            if (this.dataBoxResults.length === 1 && this.dataBoxResults[0].IsClientActive) {
                this.setVehicle(this.dataBoxResults[0]);
            }
        });
    }

    setVehicle(vehicle: any) {
        this.loadingService.setLoading(true);

        const response: ISearchVehicleBoxResponse = {
            vehicle: undefined,
            customer: undefined
        };

        this.getVehicle(vehicle.Chassis).subscribe((respVehicle) => {
            response.vehicle = respVehicle;

            this.getCustomer(vehicle.CustomerCode).subscribe((respCustomer) => {
                response.customer = respCustomer;
                this.loadingService.setLoading(false);
                this.updateVehicle.next(response);
            });

        });
    }

    getVehicle(chassis: any) {
        const _URL_ = `Services/Workshop/VehicleService.svc/GetByChassisWithCarCodes`;
        const body = {
            searchValue: chassis
        };
        return this.newPost(_URL_, body);
    }

    getCustomer(customerCode: string) {
        const _URL_ = `Services/General/CustomerService.svc/GetByCustomerCodeWithContacts`;
        const body = {
            searchValue: customerCode
        };
        return this.newPost(_URL_, body);
    }

    clearBoxResults() {
        this.dataBoxResults = [];
    }

    clearAll() {
        this.dataBoxResults = [];
    }
}
